const pageNameKey = "alarmListNode";

export const alarmListNodeEn = {
  [pageNameKey]: {
    placeholderText: "Enter string value...",
    nodeIconAltText: "Node icon",
    equal: "=",
    notEqual: "!=",
    contains: "contains",
    notContains: "not contains",
    greaterThan: ">",
    lessThan: "<",
    greaterThanOrEqual: ">=",
    lessThanOrEqual: "<=",
    warningTriangleAltText: "Warning triangle",
    warningText:
      "WARNING: Alarms for this node will not be triggered because data is no longer being collected for it, as it is no longer included in the client configuration.",
    emptyInputWarning: "Input a valid input for an active alarm.",
    enterValidNumber: "Please enter a valid number",
    firstConditionMustBeSmaller:
      "First condition must be smaller than the second condition.",
    secondConditionMustBeGreater:
      "Second condition must be greater than the first condition.",
    placeholderMin: "Min",
    placeholderMax: "Max",
  },
};

export const alarmListNodePtBr = {
  [pageNameKey]: {
    placeholderText: "Digite o valor da string...",
    nodeIconAltText: "Ícone de nó",
    equal: "=",
    notEqual: "!=",
    contains: "contém",
    notContains: "não contém",
    greaterThan: ">",
    lessThan: "<",
    greaterThanOrEqual: ">=",
    lessThanOrEqual: "<=",
    warningTriangleAltText: "Triângulo de advertência",
    warningText:
      "AVISO: Os alarmes para este nó não serão disparados, porque os dados não estão mais sendo coletados para ele, pois ele não está mais incluído na configuração do cliente.",
    emptyInputWarning: "Insira uma entrada válida para um alarme ativo.",
    enterValidNumber: "Por favor, insira um número válido",
    firstConditionMustBeSmaller:
      "A primeira condição deve ser menor que a segunda condição.",
    secondConditionMustBeGreater:
      "A segunda condição deve ser maior que a primeira condição.",
    placeholderMin: "Mín.",
    placeholderMax: "Máx.",
  },
};

export const alarmListNodeDe = {
  [pageNameKey]: {
    placeholderText: "Gebe String-Wert ein...",
    nodeIconAltText: "Node icon",
    equal: "=",
    notEqual: "!=",
    contains: "contains",
    notContains: "not contains",
    greaterThan: ">",
    lessThan: "<",
    greaterThanOrEqual: ">=",
    lessThanOrEqual: "<=",
    warningTriangleAltText: "Warndreieck",
    warningText:
      "WARNUNG: Alarme für diesen Knoten werden nicht ausgelöst, da keine Daten mehr dafür gesammelt werden, weil er nicht mehr in der Client-Konfiguration enthalten ist.",
    emptyInputWarning:
      "Gebe einen gültigen Eintrag für einen aktiven Alarm ein.",
    enterValidNumber: "Gebe einen gültigen Wert ein",
    firstConditionMustBeSmaller:
      "Die erste Bedingung muss kleiner sein als die zweite Bedingung.",
    secondConditionMustBeGreater:
      "Zweite Bedingung muss größer sein als die erste Bedingung.",
    placeholderMin: "Min",
    placeholderMax: "Max",
  },
};

export const alarmListNodeZhHans = {
  [pageNameKey]: {
    placeholderText: "输入字符串值...",
    nodeIconAltText: "节点图标",
    equal: "=",
    notEqual: "!=",
    contains: "contains",
    notContains: "not contains",
    greaterThan: ">",
    lessThan: "<",
    greaterThanOrEqual: ">=",
    lessThanOrEqual: "<=",
    warningTriangleAltText: "警告三角形",
    warningText:
      "警告：此节点的警报不会被触发，因为不再为其收集数据，因为它不再包含在客户端配置中。",
    emptyInputWarning: "输入一个有效的活动警报输入。",
    enterValidNumber: "请输入一个有效的数字",
    firstConditionMustBeSmaller: "第一个条件必须小于第二个条件。",
    secondConditionMustBeGreater: "第二个条件必须大于第一个条件。",
    placeholderMin: "最小值",
    placeholderMax: "最大值",
  },
};

export const alarmListNodeIt = {
  [pageNameKey]: {
    placeholderText: "Inserisci il valore della stringa...",
    nodeIconAltText: "Icona del nodo",
    equal: "=",
    notEqual: "!=",
    contains: "contiene",
    notContains: "non contiene",
    greaterThan: ">",
    lessThan: "<",
    greaterThanOrEqual: ">=",
    lessThanOrEqual: "<=",
    warningTriangleAltText: "Attenzione!",
    warningText:
      "ATTENZIONE: gli allarmi per questo nodo non verranno attivati poiché non è più incluso nella configurazione del client.",
    emptyInputWarning: "Inserire un valore valido per attivare un allarme.",
    enterValidNumber: "Inserisci un numero valido",
    firstConditionMustBeSmaller:
      "La prima condizione deve essere inferiore alla seconda condizione.",
    secondConditionMustBeGreater:
      "La seconda condizione deve essere maggiore della prima condizione.",
    placeholderMin: "Minimo",
    placeholderMax: "Massimo",
  },
};

export const alarmListNodeEs = {
  [pageNameKey]: {
    placeholderText: "Introduzca el valor de la cadena...",
    nodeIconAltText: "Icono de nodo",
    equal: "=",
    notEqual: "!=",
    contains: "contiene",
    notContains: "no contiene",
    greaterThan: ">",
    lessThan: "<",
    greaterThanOrEqual: ">=",
    lessThanOrEqual: "<=",
    warningTriangleAltText: "Triángulo de advertencia",
    warningText:
      "ADVERTENCIA: Las alarmas de este nodo no se activarán porque ya no se recopilan datos para él, ya que ya no está incluido en la configuración del cliente.",
    emptyInputWarning: "Introduce una entrada válida para una alarma activa.",
    enterValidNumber: "Por favor, introduce un número válido",
    firstConditionMustBeSmaller:
      "La primera condición debe ser menor que la segunda condición.",
    secondConditionMustBeGreater:
      "La segunda condición debe ser mayor que la primera condición.",
    placeholderMin: "Min",
    placeholderMax: "Máx.",
  },
};

export const alarmListNodeNl = {
  [pageNameKey]: {
    contains: "bevat",
    emptyInputWarning: "Voer een geldige invoer in voor een actief alarm.",
    enterValidNumber: "Voer een geldige waarde in",
    equal: "=",
    firstConditionMustBeSmaller:
      "De eerste voorwaarde moet kleiner zijn dan de tweede voorwaarde.",
    greaterThan: ">",
    greaterThanOrEqual: ">=",
    lessThan: "<",
    lessThanOrEqual: "<=",
    nodeIconAltText: "Node-pictogram",
    notContains: "bevat niet",
    notEqual: "!=",
    placeholderMax: "Max",
    placeholderMin: "Min",
    placeholderText: "Voer tekstwaarde in...",
    secondConditionMustBeGreater:
      "De tweede voorwaarde moet groter zijn dan de eerste voorwaarde.",
    warningText:
      "WAARSCHUWING: Alarmen voor deze node worden niet geactiveerd omdat er geen gegevens meer voor worden verzameld, aangezien deze niet langer in de clientconfiguratie is opgenomen.",
    warningTriangleAltText: "Gevarendriehoek",
  },
};

export const alarmListNodeTr = {
  [pageNameKey]: {
    contains: "içerir",
    emptyInputWarning: "Aktif bir alarm için geçerli bir giriş girin.",
    enterValidNumber: "Lütfen geçerli bir numara girin",
    equal: "=",
    firstConditionMustBeSmaller: "İlk koşul ikinci koşuldan küçük olmalıdır.",
    greaterThan: ">",
    greaterThanOrEqual: ">=",
    lessThan: "<",
    lessThanOrEqual: "<=",
    nodeIconAltText: "Düğüm simgesi",
    notContains: "içermiyor",
    notEqual: "!=",
    placeholderMax: "Maksimum",
    placeholderMin: "Min.",
    placeholderText: "Dize değerini girin...",
    secondConditionMustBeGreater: "İkinci koşul ilk koşuldan büyük olmalıdır.",
    warningText:
      "UYARI: Artık istemci yapılandırmasına dahil edilmediğinden dolayı veriler artık toplanmadığından bu düğüm için alarmlar tetiklenmeyecektir.",
    warningTriangleAltText: "Uyarı üçgeni",
  },
};
